export interface ImageItemModel {
	_id: string;
	src: string;
	title: string;
	date: Date;
}